/**
 * GENERATED by scripts/generate-version.js. Do not edit.
 */
export const version = {
  commit: 'beb0de8',
  build: '20261103.5',
  builtAt: '2026-11-03T12:39:39.520Z',
};
